import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/suggestHotels', request, cancelToken)
}

export {get}
